<template>
  <div>
    <v-container fluid class="bg-white pa-5 ma-0">
      <search-bar />
      <modal-select-manager
        v-if="$hasAnyRole(['IELManager'])"
        v-model="isOpenSelectManager"
      />
      <div v-if="!isDisablePage && !manager.loading">
        <v-row class="ma-3 pa-2 card-border-red">
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="3"
            xl="3"
            class="justify-center ma-0"
          >
            <manager-card :manager="manager" class="h-100" />
          </v-col>
          <v-col cols="12" sm="6" md="9" lg="9" xl="9">
            <div class="d-flex align-items-center h-100">
              <orders-table
                :chnl="manager.channel"
                class="justify-center ma-0 w-100"
              />
            </div>
          </v-col>
          <v-col cols="12">
            <monthly-summary
              :chnl="manager.channel"
              @desactiveLoader="finishBilling = true"
            />
          </v-col>
          <v-col cols="12">
            <backorders :chnl="manager.channel" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <fill-rate
              :user-id="manager.managerId"
              :option="manager.channel == 'PR' ? 'SG' : 'G'"
              :chnl="manager.channel"
            />
          </v-col>
        </v-row>
        <v-row v-if="manager">
          <v-col cols="12" md="12">
            <users-list :user="manager.managerId" :chnl="manager.channel" />
          </v-col>
        </v-row>
        <confidentiality-notice />
      </div>
    </v-container>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';

  import numbersFormats from '@/mixins/numbersFormats';
  import MixinService from '@/mixins/service';
  import loader from '@/mixins/loader';
  import { getGeneralInfo } from '@/repositories/Daily';

  import FillRate from '@/views/fill_rate/FillRate.vue';
  import ManagerCard from './includes/ManagerCard.vue';
  import OrdersTable from '../components/OrdersTable.vue';
  import MonthlySummary from '../components/MonthlySummary.vue';
  import Backorders from '../components/Backorders.vue';
  import UsersList from '../components/UsersList.vue';
  import SearchBar from './components/SearchBar.vue';

  import ConfidentialityNotice from '@/components/ConfidentialityNotice.vue';
  import ModalSelectManager from './components/ModalSelectManager.vue';

  export default {
    name: 'ManagerHome',
    components: {
      ManagerCard,
      MonthlySummary,
      Backorders,
      ConfidentialityNotice,
      ModalSelectManager,
      FillRate,
      UsersList,
      SearchBar,
      OrdersTable,
    },
    mixins: [MixinService, loader, numbersFormats],
    data: () => ({
      finishSeller: false,
      finishBilling: false,
      managerData: [],
      isDisablePage: false,
      isOpenSelectManager: false,
      manager: {
        managerId: '',
        channel: '',
        VKORG: '',
        error: '',
        data: [],
        loading: true,
      },
    }),
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
    },
    watch: {
      finishSeller() {
        this.validateLoader();
      },
    },
    created() {
      const manager = this.$getLocalStorageManager();
      this.manager.managerId = this.fillNumberToNDigits(
        manager ? manager : this.user.sap_id,
        8
      );
      this.manager.VKORG = this.user.VKORG;
      this.manager.channel = this.user.VTWEG;
      if (this.$hasAnyRole(['IELManager']) && !manager) {
        this.isDisablePage = true;
        this.isOpenSelectManager = true;
        this.desactiveLoader();
      }
    },

    mounted() {
      this.getManagerInfo();
    },

    methods: {
      ...mapActions({
        desactiveLoader: 'loader/desactiveLoader',
      }),
      async getManagerInfo() {
        this.manager.loading = true;
        this.manager.error = '';
        try {
          this.manager.data = await getGeneralInfo(
            this.manager.managerId,
            this.manager.channel
          );
        } catch (error) {
          this.manager.error = error.message;
          this.manager.loading = false;
        }
        this.manager.loading = false;
        this.finishSeller = true; //temporal
      },
      validateLoader() {
        if (!this.manager.loading) {
          this.desactiveLoader();
        }
      },
    },
  };
</script>
<style scoped src="../../../../public/css/managercustom.css"></style>
